import { render, staticRenderFns } from "./my-order.vue?vue&type=template&id=0c247522&scoped=true"
import script from "./my-order.vue?vue&type=script&lang=js"
export * from "./my-order.vue?vue&type=script&lang=js"
import style0 from "./my-order.vue?vue&type=style&index=0&id=0c247522&prod&lang=scss&scoped=true"
import style1 from "./my-order.vue?vue&type=style&index=1&id=0c247522&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c247522",
  null
  
)

export default component.exports